var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Page",
    { attrs: { title: _vm.title } },
    [
      _c(
        "div",
        { staticClass: "pageView-index" },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.shows,
                  expression: "shows"
                }
              ],
              staticClass: "logo"
            },
            [
              _c("img", {
                attrs: { src: require("@/assets/img/logo.png"), alt: "" }
              })
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.list, function(items, index) {
            return _c("div", { key: index, staticClass: "menu_list_flex" }, [
              _c("div", { staticClass: "header-wrapper" }, [
                _c("div", { staticClass: "menu_headerTitl" }, [
                  _vm._v(_vm._s(items.name))
                ]),
                _vm._v(" "),
                items.name === "客户管理" && _vm.$wxuserUtil.isRoleSwitch()
                  ? _c("div", { staticClass: "role-switch-container" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.tempSelectedValue,
                              expression: "tempSelectedValue"
                            }
                          ],
                          staticClass: "role-select",
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.tempSelectedValue = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                              _vm.handleSelectChange
                            ]
                          }
                        },
                        [
                          !_vm.tempSelectedValue
                            ? _c(
                                "option",
                                { attrs: { disabled: "", value: "" } },
                                [_vm._v("请选择角色")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.selectOptions, function(option) {
                            return _c(
                              "option",
                              {
                                key: option.value,
                                domProps: { value: option.value }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(option.text) +
                                    "\n            "
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex" },
                _vm._l(items.subMenuList, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "menu_list",
                      on: {
                        click: function($event) {
                          return _vm.navigation_(item.id, item)
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: item.icon
                            ? _vm.http + item.icon
                            : require("@/assets/img/1.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "menu_list_font" }, [
                        _vm._v(_vm._s(item.name))
                      ]),
                      _vm._v(" "),
                      item.num != 0
                        ? _c("div", { staticClass: "statues" }, [
                            _vm._v(_vm._s(item.num))
                          ])
                        : _vm._e()
                    ]
                  )
                }),
                0
              )
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("van-dialog", {
        attrs: {
          title: "确认选择",
          message: _vm.confirmMessage,
          "show-cancel-button": ""
        },
        on: { confirm: _vm.onConfirm, cancel: _vm.onCancel },
        model: {
          value: _vm.showConfirmDialog,
          callback: function($$v) {
            _vm.showConfirmDialog = $$v
          },
          expression: "showConfirmDialog"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-826af616", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-826af616","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/index.vue
// module id = null
// module chunks = 